module.exports = __webpack_public_path__ + "static/sander-doorn-8783d75989b919c46c8cd824cecd9aab.png";